module.exports = __webpack_public_path__ + "assets/size-litsview.5823789f.svg";